import React from "react";
import styles from "./personalisation-carousel.module.scss";
import PersonalisationVis from "./personalisation-vis";
import useDimensions from "../../hooks/useDimensions";
import Carousel from "nuka-carousel";
import { IconArrowRight } from "../icons";
import useScreenVisible from "../../hooks/useScreenVisible";
import gtmPush from "../../modules/gtm";

const PersonalisationCarousel = props => {
    const { cardData, isOpen } = props;

    const carouselRef = React.useRef(null);
    const carouselDimensions = useDimensions(carouselRef);
    const [openCards, setOpenCards] = React.useState([0]);

    const markCardOpened = React.useCallback(
        index => {
            if (openCards.includes(index)) return;
            setOpenCards([...openCards, index]);
            gtmPush({
                event: "personalisation-slide",
                slide: index,
            });
        },
        [openCards]
    );

    // We fade in 0 when we first load. It's always the one in view when we first see it.
    // const visibleRef = useScreenVisible(() => markCardOpened(0));

    const cards = cardData.map((card, cardIndex) => {
        return (
            <PersonalisationCard
                key={cardIndex}
                index={cardIndex}
                cardData={card}
                opened={openCards.includes(cardIndex)}
            />
        );
    });

    const [slideWidth, setSlideWidth] = React.useState(600);

    React.useLayoutEffect(() => {
        if (!carouselDimensions) return;

        let newSlideWidth = carouselDimensions.width - 96;
        if (newSlideWidth > 600) newSlideWidth = 600;

        setSlideWidth(newSlideWidth + 32 / 2);
    }, [carouselDimensions]);

    const smallOverlays = React.useMemo(() => {
        return carouselDimensions && carouselDimensions.width < 650;
    }, [carouselDimensions]);

    return (
        <div className={styles.personalisationCarousel} data-open={isOpen} ref={carouselRef}>
            <Carousel
                scrollMode="remainder"
                slidesToShow={3}
                slidesToScroll={1}
                cellAlign="center"
                cellSpacing={32}
                transitionMode="scroll"
                slideWidth={slideWidth + "px"}
                renderCenterLeftControls={({ previousSlide }) => (
                    <div
                        className={styles.personalisationCarouselOverlay}
                        data-side="left"
                        data-small={smallOverlays}
                        onClick={previousSlide}
                    />
                )}
                renderCenterRightControls={({ nextSlide }) => (
                    <div
                        className={styles.personalisationCarouselOverlay}
                        data-side="right"
                        data-small={smallOverlays}
                        onClick={nextSlide}
                    />
                )}
                disableEdgeSwiping
                defaultControlsConfig={{
                    pagingDotsContainerClassName: styles.pageDots,
                    pagingDotsClassName: styles.pageDot,
                }}
                afterSlide={markCardOpened}
            >
                {cards}
            </Carousel>
        </div>
    );
};

const PersonalisationCard = props => {
    const { cardData, index, opened } = props;
    const visRef = React.useRef(null);
    const dimensions = useDimensions(visRef);
    return (
        <div className={styles.cardOuter}>
            <div className={styles.card}>
                <div className={styles.cardHeader}>
                    <div
                        className={styles.cardHeading}
                        dangerouslySetInnerHTML={{ __html: index + 1 + ". " + cardData.label }}
                    />
                </div>
                <div className={styles.cardVisArea} ref={visRef}>
                    {dimensions && (
                        <PersonalisationVis
                            dimensions={dimensions}
                            cardData={cardData}
                            opened={opened}
                        />
                    )}
                </div>

                <a
                    href={cardData.actionUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cardButton}
                >
                    {cardData.action} <IconArrowRight />
                </a>
            </div>
        </div>
    );
};

export default PersonalisationCarousel;
